import { useTags } from "data-hooks/company/tags/tags.service";
import { Tag } from "data-hooks/company/tags/tags.type";
import { mapTagsToOptions } from "data-hooks/company/tags/tags.utils";
import { SelectInputData, SelectInputField } from "../../../components/deprecated/SelectInputField/SelectInputField";

type Props = {
  propertyId?: string | string[];
  companyId?: string;
  width?: string;
  changedSelected: (routine: Tag[]) => void;
  placeholder?: string;
  className?: string;
  defaultSelected?: string[];
  dataCy?: string;
  isDisabled?: boolean;
  menuPortalTarget?: HTMLElement | "popup" | "insideModal";
};

export const TagSelector = (props: Props) => {
  const { tags } = useTags({ propertyId: props.propertyId, companyId: props.companyId });

  const tagList = tags ?? [];

  const tagOptions: SelectInputData[] = mapTagsToOptions(tagList);

  return (
    <div className={`selector ${props.className ?? ""}`}>
      <SelectInputField
        {...props}
        width={props.width}
        placeholder={props.placeholder}
        options={tagOptions}
        multi
        menuPortalTarget={props.menuPortalTarget}
        useCustomSort
        disabled={props.isDisabled}
        value={props.defaultSelected}
        onChange={(values) => {
          const selectedTags: Tag[] = [];
          for (const value of values) {
            const tag = tagList.find((tag) => tag.id === value?.value);
            if (tag) {
              selectedTags.push(tag);
            }
          }
          props.changedSelected(selectedTags);
        }}
      />
    </div>
  );
};

